import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as userDataActions from '../actions/user-data.actions';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { NEVER, of } from 'rxjs';
import { UserDataGateway } from '../gatewayy/user-data.gateway';
import { BoelsUserTypeEnum, UserEnum } from '@boels/models';
import { UserTypeService } from '@boels/helpers';

@Injectable({
  providedIn: 'any',
})
export class UserDataEffects {
  private actions$ = inject(Actions);
  private userDataGateway = inject(UserDataGateway);

  #userTypeService = inject(UserTypeService);

  setUserData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userDataActions.setUserData),
      switchMap((action) => {
        const user = action.user;
        if (user.type !== UserEnum.B2C_AUTHENTICATED) {
          return NEVER;
        }
        return this.userDataGateway.getUserDebtorData(user.b2cToken).pipe(
          tap((debtor) => {
            debtor.accounts.forEach((account) => {
              account.displayValue = `${account.name} | ${account.debtorNumber}`;
            });
            if (!debtor.firstName) debtor.firstName = '-';
            if (!debtor.lastName) debtor.lastName = '-';
            user.debtor = debtor;
            this.#userTypeService.setUserType(BoelsUserTypeEnum.REGISTERED);
          }),
          map(() => userDataActions.setUserDataSuccess({ user })),
          catchError(() =>
            of(userDataActions.setUserDataFailure({ error: true })),
          ),
        );
      }),
    ),
  );
}
